import { Route } from '@angular/router';
import { authGuard } from '@front/frontend/data-access-auth/guards/auth.guard';
import { LayoutComponent } from '@front/shared/ui-layout/layout';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'private-area',
        canMatch: [authGuard],
        loadChildren: () => import('@front/frontend/private-area/feature'),
      },
      {
        path: 'mi-zona',
        canMatch: [authGuard],
        loadChildren: () => import('@front/frontend/private-area/feature'),
      },
      {
        path: 'auth',
        loadChildren: () => import('@front/frontend/feature-auth'),
      },
      {
        path: '',
        loadChildren: () => import('@front/frontend/feature-public'),
      },
    ],
  },
];
